import { GoogleMap } from '@react-google-maps/api';
import { mapOptions } from 'map/Map';
import { JP_CENTER } from 'map/MapContent';
import React, { PropsWithChildren } from 'react';

interface Props {}

const options: google.maps.MapOptions = {
  ...mapOptions,
  center: JP_CENTER,
  zoom: 5,
};

const AdminBoxMap = ({ children }: PropsWithChildren<Props>) => {
  return <GoogleMap options={options}>{children}</GoogleMap>;
};

export default AdminBoxMap;
